import React from 'react';
import NavigationBar from '../../navigationbar';
import Footer from '../../footer';

import './gbv.css';

import GBV_Logo from '../../assets/Frauen gelber Hintergrund/1.jpg';

function Geburtsvorbereitung() {
  return (
    <>
      <NavigationBar/>
       
      <section className="gbv-picture">
        <div className="gbv-img-content">
          <img className="gbv-main-logo" src={GBV_Logo} alt="gbv mit Herz"/>
        </div>
        <div className="gbv-content">
          <strong>Du hast Angst vor Schmerzen bei der Geburt?<br/>
            Möchtest du die Geburt deines Kindes selbst in die Hand nehmen?<br/>
            Selbst mit gestalten, wie deine Geburt wird, anstatt den "Schmerzen" einfach ausgeliefert zu sein?<br/>
            Raus aus der Ohnmacht, rein in die Selbstbestimmung und deine eigene weibliche Kraft?<br/>
          </strong>
          <p>
            
            Ja, das geht!<br/>
            Ich kann dir zeigen, wie du deine ganz eigene Strategie entwickelst und übst!<br/>
            <strong>Für weniger Angst und Schmerzen,<br/>
              für mehr selbstbestimmte und<br/>
              kraftvolle Geburten!
            </strong>
          </p>
        </div>
      </section>

      <section>
        <div className='gbv-explain'>
          <h2><em><strong>Die falschen Grundannahmen</strong></em></h2>
          <p>
            Mein Herzenswunsch ist es, Schwangerschaft und Geburt in unseren Köpfen positiver zu verankern, damit die Geburt deines Babys ein Fest der Liebe und Freude sein kann! In Filmen und auch in Berichten von Familie und Freunden werden meist nur negative Aspekte der Schwangerschaft und Geburt beleuchtet...
          </p>
          <p>
            Ja, Geburt kann weh tun! Warum man das so erlebt hat und ob das die Norm ist, darüber macht sich kaum einer Gedanken! Jetzt mal ehrlich: Warum sollte die Natur es so einrichten, dass unser Fortbestehen, also das Wichtigste für unsere Art überhaupt, soooo unglaublich schrecklich und schmerzhaft sein soll?!?! Klingt unlogisch? Ist es auch! Würden andere Säugetiere bei der Geburt unter unsagbaren Schmerzen schreien, käme gleich der nächste Wolf oder Löwe und würde Mutter samt Kind fressen...
          </p>
          <p>
            Die Annahme, man könne nichts dagegen tun, dass Geburt halt schmerzhaft, schrecklich und gefährlich sei, ist biologisch gesehen vollkommener Unsinn, aber dennoch weit verbreiteter Glaube und für viele Frauen pure und harte, manchmal sogar traumatische Realität! Das alles ist Geburt aber nicht per se, es kann auch ganz anders aussehen!
          </p>
          <p>
            Aber auch, wenn du es dir aufgrund deiner momentanen Glaubenssätze vielleicht gar nicht vorstellen kannst:
          </p>
          <p>
            <strong>Du kannst lernen deinen Körper während der Geburt zu unterstützen, mit ihm zu arbeiten statt gegen ihn, auf diese Weise deine Geburt selbstbestimmt mit zu gestalten und so zu einem kraftvollen und wunderschön-stärkenden Erlebnis werden zu lassen (und dich dadurch mit vorherigen negativen Erfahrungen zum Teil versöhnen)!</strong>
          </p>
          <p>
            <strong>Und genau das möchte ich dir zeigen!</strong>
          </p>
          <p>
            <strong>In <a href="https://herznah.tentary.com/p/E5ItGG" target="_blank" rel="noopener noreferrer">meinem Kurs STARK in die Geburt und Wochenbett!</a> lernst und übst du Stück für Stück (mit deinem Geburtsbegleiter), was dich in deiner Geburt unterstützen kann, um eine selbstbestimmte Geburt zu erleben!</strong>
          </p>
          <p>
            <strong>Du hast 3 Wahlmöglichkeiten für deine mentale Geburtsvorbereitung mit mir:</strong>
          </p>
        </div>
      </section>

      <section>
        <div className='gbv-explain-2'>
          <div className='gbv-list cards'>
            <div className='gbv-listitem card'>
              <a href="https://herznah.tentary.com/p/E5ItGG" target="_blank" rel="noopener noreferrer" className="gbv-clickable-card">
                <h3>1. Onlinekurs</h3>
                <p>Du kannst dir in meinem Shop ganz einfach meinen Onlinekurs holen und die Videos und Audios sehen und hören, wann es für dich gerade passend ist!</p>
              </a>
            </div>
            <div className='gbv-listitem card'>
              <a href="/kontakt" className="gbv-clickable-card">
                <h3>2. Persönliches Coaching vor Ort</h3>
                <p>Rund um Lauenbrück können wir uns zu einem persönlichen Coaching vor Ort treffen.</p>
              </a>
            </div>
            <div className='gbv-listitem card'>
              <a href="https://herznah.tentary.com/p/98HT1m" target="_blank" rel="noopener noreferrer" className="gbv-clickable-card">
                <h3>3. Online Coaching über Zoom</h3>
                <p>Online über Zoom hast die Möglichkeit von überall aus ein individuelles Coaching mit mir zu bekommen.</p>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className='gbv-explain'>
          <p>
            Egal, ob du dein erstes Baby erwartest oder schon Kinder hast:<br/>
            <strong>Ich passe mein Angebot gerne ganz individuell an dich an, je nachdem was du und dein Geburtsbegleiter braucht!</strong>
          </p>
        </div>
      </section>

      <section>
        <div className='gbv-explain'>
          <h2><em><strong>Warum braucht man eine Vorbereitung für die Geburt?</strong></em></h2>
          <p>
            Klingt total übertrieben oder? Früher haben die Frauen sich auch nicht "vorbereitet"... Klingt nach Arbeit und Stress! Warum solltest du dir sowas antun?
          </p>
          <p>
            Geburt ist oft eine große Herausforderung, bringt Unsicherheiten und Ängste mit sich oder auch das Gefühl einer Ohnmacht und des Überrolltwerdens... Eine positive Geburtserfahrung hat aber nicht nur mit Glück zu tun oder ist einfach nur Zufall, sondern hat auch mit deiner (mentalen) Vorbereitung zu tun.
          </p>
          <p>
            Ich habe am eigenen Leib erfahren, wie wirkungsvoll man seine Geburt mit beeinflussen kann und möchte genau das an so viele Frauen wie möglich weiter geben! Als Yogalehrerin und Coach und mit meinem ganzen angesammelten Wissen kann ich dich hier einfühlsam und stärkend an die Hand nehmen und dir deinen Weg zeigen.
          </p>
          <p>
            <strong>Es ist wichtig, wie wir geboren werden!</strong><br/>
            Nicht nur für das Baby, sondern auch für die Mutter und die ganze Familie!
          </p>
          <p>
            <strong>Deshalb möchte ich dich in deinem Vertrauen, in deiner Selbstbestimmung stärken,<br/>
            dir zeigen, wie du (wieder) in deine weibliche Kraft kommst<br/>
            und dir dafür handfeste Strategien mit an die Hand geben!</strong>
          </p>
          <p>
            <strong>Durch <a href="https://herznah.tentary.com/p/E5ItGG" target="_blank" rel="noopener noreferrer">meinen Kurs</a> lernst du, wie du selbst den Verlauf deiner Geburt mit gestaltest, dich stärkst und dich selbst durch diese Herausforderung trägst!</strong>
          </p>
        </div>
      </section>

      <section>
        <div className='gbv-explain'>
          <h2><strong><em>Aufbau des Kurses</em></strong></h2>
          <p>
            Schmerzen und andere negative Empfindungen während den Herausforderungen einer Geburt entstehen oft durch Angst oder Unsicherheiten und der daraus resultierenden körperlichen oder auch geistigen Anspannung! Damit du und ihr mit den verschiedenen Herausforderungen während der Geburt umgehen könnt, erfahrt ihr in meinem Kurs durch welche Zusammenhänge genau Geburtsschmerz entsteht. Anschließend lernt ihr verschiedene Methoden der Entspannung, Atmung und des positiven Denkens kennen, um das ganz individuell für euch passende zu finden, auch nach einer vorherigen negativen Geburtserfahrung!
          </p>
          <p>
            Mit einer klaren und persönlichen Strategie könnt ihr dann zu Hause weiter üben, um selbstsicherer, gestärkt und zuversichtlich in die Geburt und das Wochenbett zu gehen!
          </p>
          <p>
            <strong>Du bist bereit, die Geburt deines Kindes in deine Hände zu nehmen und möchtest sie aktiv selber gestalten?</strong>
          </p>
          <p>
            Dann hole dir <a href="https://herznah.tentary.com/E5ItGG" target="_blank" rel="noopener noreferrer">meinen Onlinekurs </a>oder melde dich <a href="/kontakt">bei mir </a>für ein kostenloses Kennenlerngespräch und wir schauen uns einfach einmal gemeinsam an, was du noch brauchst, um die Geburt deines Babys zu DEINER stärkenden Geburt werden zu lassen, die du und dein Baby euch wünscht!
          </p>
          <p>
            <strong>Ich freue mich auf dich/euch!</strong>
          </p>
        </div>
      </section>

      <Footer color="geburtsvorbereitung"/>
    </>
  );
}

export default Geburtsvorbereitung;
